import { TableCell } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { StyledTableRow } from "components/BulkUpload";
import React from "react";
import { useWatch, useFieldArray } from "react-hook-form";
import {
  getErrors,
} from "./utils";
import { InputLabel } from "components/BulkUpload";

const days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
const lgUp = "79px";
const lgDown = "70px";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
  formControl: {
    minWidth: "200px",
  },
  hrsField: {
    minWidth: lgDown,
    maxWidth: lgDown,
  },
  [theme.breakpoints.up("xl")]: {
    hrsField: {
      minWidth: lgUp,
      maxWidth: lgUp,
    },
  },
  number: {
    fontSize: 14,
    textAlign: "center",
    "&[type=number]": {
      "-moz-appearance": "textfield",
      "-webkit-appearance": "textfield",
    },
    "&::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "&::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
  textArea: {
    width:'fit-content',
    textAlign:'left'
  }
}));

const PunchRows = (props) => {
  const classes = useStyles();
  const {
    disabled,
    register,
    control,
    onUpdate,
    setValue,
    getValues,
    trigger,
    errors,
    dropdowns,
  } = props;

  const { fields, append } = useFieldArray({
    control,
    name: "records",
  });

  const records = useWatch({ control, name: "records" });
  const activityTotal = useWatch({ control, name: "activityTotal" });

  return (
    <>
    {fields.map((record, index) => (
      <StyledTableRow className={classes.root}>
        <TableCell align="left">
          <InputLabel 
            name={`records[${index}].details`}
            value = {records[index]['details']}
            fullWidth
            readOnly
            inputProps={{
              readOnly: true,
              className: classes.textArea
            }}
            multiline
            inputRef={register()}
          />
        </TableCell>
        {days.map((days, i) => (
          <TableCell key={i} align="center">
                <TextField
                  name={`records[${index}].day${i + 1}`}
                  size="small"
                  variant="outlined"
                  value = {records[index][`day${i + 1}`]}
                  className={classes.hrsField}
                  type="number"
                  inputRef={register({
                    min:0,
                    max:24
                  })}
                  onKeyDown={(evt) =>
                    ["e", "E", "+", "-"].includes(evt.key) &&
                    evt.preventDefault()
                  }
                  fullWidth
                  inputProps={{
                    min: 0,
                    max: 24,
                    className: classes.number,
                    readOnly: false,
                  }}
                  error={getErrors(errors.records, index, `day${i + 1}`)}
                  placeholder={"0"}
                  onChange={(e) => {
                    let eventValue = e.target.value;
                    e.persist();
                    e.target.value = e.target.value
                      ? parseFloat(e.target.value)
                      : 0;
                    e.target.value =
                      eventValue.indexOf(".") >= 0
                        ? eventValue.substr(0, eventValue.indexOf(".")) +
                          eventValue.substr(eventValue.indexOf("."), 3)
                        : eventValue;
                    onUpdate(index, i + 1);
                  }}
            />
          </TableCell>
        ))}
        <TableCell align="left">
          <InputLabel 
            name={`activityTotal[${records[index]['details']}].hours`}
            value = {activityTotal?.[records?.[index]?.['details']]?.['hours']}
            fullWidth
            readOnly
            inputProps={{
              readOnly: true,
              style: { textAlign: 'center' },
              className: classes.number
            }}
            inputRef={register()}
          />
        </TableCell>
      </StyledTableRow>
    ))}
    </>
  );

}

export default PunchRows;